import { MfaType } from "@/app/auth/utils/enums";
import httpManager from "@/app/shared/utils/httpManager";

class MfaConfigService {
  baseUrl = "/settings/mfa";

  async enableMfa(body: { role: number[]; time_to_expire: number; mfa_type: MfaType | null }) {
    const response = await httpManager.post(`${this.baseUrl}/enable/`, body);
    return response.data;
  }

  async disabledMfa(body: { mfa_type: MfaType | null }) {
    const response = await httpManager.post(`${this.baseUrl}/disable/`, body);
    return response.data;
  }

  async listConfigMfa() {
    const response = await httpManager.get(`${this.baseUrl}/`);
    return response.data;
  }
}

export const mfaConfigService = new MfaConfigService();
